import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-338">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 z-50 backdrop-blur-sm" data-id="element-339" />
          <motion.div initial={{
        opacity: 0,
        y: '100%',
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: '100%',
        scale: 0.9
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="fixed inset-x-4 bottom-4 top-24 md:inset-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-2xl bg-charcoal-light border border-charcoal-light rounded-lg shadow-2xl z-50 flex flex-col overflow-hidden" data-id="element-340">
            <div className="flex items-center justify-between p-6 border-b border-charcoal" data-id="element-341">
              <h2 className="text-xl font-heading font-bold text-sand" data-id="element-342">
                {title}
              </h2>
              <button onClick={onClose} className="text-offwhite-dim hover:text-sand transition-colors p-2" aria-label="Close modal" data-id="element-343">
                <XIcon className="w-6 h-6" data-id="element-344" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto flex-1 text-offwhite-dim text-sm leading-relaxed space-y-4" data-id="element-345">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}